import React from 'react'
import * as S from './LegendStyles'
import { LegendItem } from 'types/RuntimeHistory'

type IndoorUnitFiltersProps = {
  showSection: boolean;
  data: Array<Required<LegendItem>>;
  isFilterItemSelected: (legendItem: LegendItem) => boolean;
  onFilterSelectionChanged: (seriesName: string) => void;
}

const IndoorUnitFilters = ({
  showSection,
  data,
  isFilterItemSelected,
  onFilterSelectionChanged
}: IndoorUnitFiltersProps) => {
  if (!showSection) return null

  return (
    <S.NonZoneSection flexWidth={370}>
      <S.Typography>Indoor Unit</S.Typography>
      <S.CheckboxGroup>
        {data?.map(legendItem => (
          <S.FilterCheckbox
            key={legendItem.seriesName}
            label={legendItem.label}
            listId="indoor_unit"
            checked={isFilterItemSelected(legendItem)}
            onChange={() => onFilterSelectionChanged(legendItem.seriesName)}
          />
        ))}
      </S.CheckboxGroup>
    </S.NonZoneSection>
  )
}

export default IndoorUnitFilters
